export default "__VITE_ASSET__DSvQq_oc__"